import { motion } from "framer-motion";

/**
 * Reusable section wrapper with grain overlay, padding and optional aura blobs.
 */
export const Section = ({ id, className = "", children, eyebrow, title, subtitle, aurora = false, testId }) => {
  return (
    <section
      id={id}
      data-testid={testId || id}
      className={`section-aj relative overflow-hidden ${className}`}
    >
      {aurora && (
        <>
          <div className="turquoise-aura -top-32 -left-40 opacity-60" />
          <div className="gold-aura bottom-0 right-0 opacity-50" />
        </>
      )}
      <div className="grain-overlay" />
      <div className="container relative z-10 mx-auto px-6 max-w-7xl">
        {(eyebrow || title || subtitle) && (
          <div className="max-w-3xl mb-16">
            {eyebrow && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.5 }}
                className="eyebrow mb-4"
              >
                {eyebrow}
              </motion.div>
            )}
            {title && (
              <motion.h2
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.55, delay: 0.05 }}
                className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]"
              >
                {title}
              </motion.h2>
            )}
            {subtitle && (
              <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.55, delay: 0.12 }}
                className="font-inter text-base md:text-lg text-white/65 mt-6 leading-relaxed"
              >
                {subtitle}
              </motion.p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`eyebrow ${className}`}>{children}</span>
);

export const StatBlock = ({ value, label, className = "" }) => (
  <div className={`flex flex-col gap-2 ${className}`}>
    <span className="font-playfair italic text-5xl md:text-7xl text-gold-200 leading-none tracking-tight">
      {value}
    </span>
    <span className="font-montserrat text-xs uppercase tracking-[0.22em] text-white/55">
      {label}
    </span>
  </div>
);

export const GlassCard = ({ children, className = "", glow = false, ...rest }) => (
  <div
    {...rest}
    className={`glass rounded-2xl p-7 transition-all duration-300 hover:bg-white/[0.055] ${
      glow ? "hover:border-turquoise/30 hover:shadow-[0_0_30px_rgba(0,200,215,0.12)]" : ""
    } ${className}`}
  >
    {children}
  </div>
);
